import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import { Form } from 'providers/Forms';

import {
  Form as FormElement,
  Input,
  PasswordInput,
  Text,
  OtherButton,
  LoginButton,
} from './elements';
import { useText, useLink } from 'common/hooks';

const deps = {
  form: state.appContainer.auth.logInForm,
  pageLoaded: state.account.pageLoaded,
  isAuthenticating: state.appContainer.auth.isAuthenticating,
  fieldChanged: sequences`appContainer.fieldChanged`,
  logInSubmitted: sequences`appContainer.auth.logInSubmitted`,
};

export function EmailForm({
  form,
  pageLoaded,
  isAuthenticating,
  fieldChanged,
  logInSubmitted,
  get,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const link = useLink();
  const logInForm = new Form(form, get) as any;

  return (
    <FormElement
      autoComplete={'off'}
      onSubmit={event => {
        event.preventDefault();
        logInSubmitted();
      }}
    >
      <Input
        disabled={!pageLoaded}
        errorMessage={
          !logInForm.email.isValid && !logInForm.email.isPristine
            ? t(
                logInForm.email.errorMessage.phrase,
                logInForm.email.errorMessage.options
              )
            : null
        }
        name={'email'}
        inputType={'email'}
        onChange={event =>
          fieldChanged({
            field: 'appContainer.auth.logInForm.email',
            value: event.target.value,
          })
        }
        placeholder={t('appContainer.ModLogin.email')}
        value={logInForm.email.value}
      />
      <PasswordInput
        disabled={!pageLoaded}
        errorMessage={
          !logInForm.password.isValid && !logInForm.password.isPristine
            ? t(
                logInForm.password.errorMessage.phrase,
                logInForm.password.errorMessage.options
              )
            : null
        }
        name={'password'}
        onChange={event =>
          fieldChanged({
            field: 'appContainer.auth.logInForm.password',
            value: event.target.value,
          })
        }
        placeholder={t('appContainer.ModLogin.password')}
        value={logInForm.password.value}
      />
      <Text color={'#677074'}>{t('authentication.dont_have_password')}</Text>
      <OtherButton
        disabled={!pageLoaded}
        href={link('forgotPassword?creationNeeded=true')}
      >
        {t('authentication.follow_steps')}
      </OtherButton>
      <LoginButton
        disabled={!logInForm.isValid || isAuthenticating || !pageLoaded}
      >
        {t('appContainer.ModLogin.login')}
      </LoginButton>
      <OtherButton disabled={!pageLoaded} href={link('forgotPassword')}>
        {t('authentication.lost_password')}
      </OtherButton>
    </FormElement>
  );
}

export default connect(deps, EmailForm);
